import React, { useEffect } from 'react';
import './AccueilModal.css';

interface AccueilModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    className?: string;
}

const AccueilModal: React.FC<AccueilModalProps> = ({ isOpen, onClose, title, children, className }) => {
    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="accueil-modal-overlay" onClick={onClose}>
            <div className={`accueil-modal${className ? ` ${className}` : ''}`} onClick={(e) => e.stopPropagation()}>
                <div className="accueil-modal-header">
                    <h2 className="accueil-modal-title">{title}</h2>
                    <button className="accueil-modal-close" onClick={onClose} aria-label="Fermer">
                        &times;
                    </button>
                </div>
                <div className="accueil-modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AccueilModal;
